import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { subscriptionService, SubscriptionStatus } from '../services/subscriptionService';
import { useAuthStore } from '../services/auth';

interface SubscriptionState {
  status: SubscriptionStatus | null;
  loading: boolean;
  error: string | null;
  loadSubscription: () => Promise<void>;
  checkProAccess: () => boolean;
}

export const useSubscriptionStore = create<SubscriptionState>()(
  persist(
    (set, get) => ({
      status: null,
      loading: false,
      error: null,

      loadSubscription: async () => {
        const user = useAuthStore.getState().user;
        if (!user) {
          set({ status: null, loading: false, error: null });
          return;
        }

        set({ loading: true, error: null });
        try {
          const status = await subscriptionService.getSubscriptionStatus(user.id);
          set({ status, loading: false });
        } catch (error) {
          set({ 
            error: error instanceof Error ? error.message : 'Failed to load subscription', 
            loading: false 
          });
        }
      },

      checkProAccess: () => {
        const { status } = get();
        return status?.isPro || false;
      }
    }),
    {
      name: 'subscription-store',
    }
  )
);
